/* 常驻组件 */
import BackTop from './BackTop';
import Customer from './Customer';

export default {
    BackTop,
    Customer
}
